import { ConnectionNames } from "../Contracts";
import { QueryBuilder } from "./Helpers";
import { BaseRESTConnection } from "../Common";
export class RealityCheckConnection extends BaseRESTConnection {
    constructor(meta) {
        super(ConnectionNames.realityCheck, meta);
    }
    getSettings() {
        return this.applyQuery(QueryBuilder.getSettings());
    }
    saveSettings(settings) {
        return this.applyQuery(QueryBuilder.saveSettings(settings));
    }
    getWageringInformation() {
        return this.applyQuery(QueryBuilder.getWageringInformation());
    }
}
//# sourceMappingURL=RealityCheckConnection.js.map